import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";
import "./utils/vee-validate";

import axios from 'axios'
import VueAxios from 'vue-axios'
import { BootstrapVue } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/style.css';
import './assets/css/components.css';
import './assets/css/custom.css';
import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(VueAxios,axios)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
